import axiosInstance from "../../../api/axiosInstance";

let putObject = async(method, user, props, type) => {
    return new Promise((resolve, reject) => {  
        let uri = process.env.REACT_APP_API  + "/"+ method +  "/" + user.profile + "/" + user.locale; 
        if(type == "MES") {
            uri = process.env.REACT_APP_API  + "/"+ method +  "/" + props.data + "/" + user.profile + "/" + user.locale;
        }
        axiosInstance.put(uri, props.formulary).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default putObject